var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EDAD68"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(6 6)",
    fill: "#EDAD68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 7.75C12.7651 7.75 10.0366 10.1587 9.63543 13.3684L8.81133 19.9612C8.63728 21.3535 9.72295 22.5833 11.1261 22.5833H12.179L12.1897 22.6072C12.8589 24.113 14.3521 25.0833 15.9998 25.0833C17.6475 25.0833 19.1407 24.113 19.8099 22.6072L19.8205 22.5833H20.8735C22.2767 22.5833 23.3623 21.3535 23.1883 19.9612L22.3642 13.3684C21.963 10.1587 19.2345 7.75 15.9998 7.75ZM19.3503 21.0833C19.3391 21.0831 19.3279 21.0831 19.3168 21.0833H12.6828C12.6716 21.0831 12.6605 21.0831 12.6493 21.0833H11.1261C10.6252 21.0833 10.2376 20.6443 10.2997 20.1472L11.1238 13.5544C11.4312 11.0954 13.5216 9.25 15.9998 9.25C18.478 9.25 20.5684 11.0954 20.8758 13.5544L21.6999 20.1472C21.762 20.6443 21.3744 21.0833 20.8735 21.0833H19.3503ZM13.9166 22.5833H18.0829C17.5838 23.2061 16.8219 23.5833 15.9998 23.5833C15.1777 23.5833 14.4157 23.2061 13.9166 22.5833Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ebbdeb12f1a3035b9b3a2461e910ab60.svg";
export { ForwardRef as ReactComponent };